import React from 'react'
import { Button, Col, Modal } from 'reactstrap'
import { HeaderModal } from '../Basicos'

const ModalCritiaGrupos = ({ isOpen, atualizarGrupos, dados }) => {
    return (
        <Modal isOpen={isOpen} className="modal-atualizar-local">
            <HeaderModal
                icon={false}
                titulo={'Salvar'}
                sm={12}
                colClassName="modalConsulta__menu atualizar-aula"
            />
            <Col sm={12} style={{ fontSize: '0.9rem', padding: '8px', color: 'var(--cor-text-secundario)', textAlign: 'center' }}>
                Há grupos que não estão em sequência! Deseja continuar?
            </Col>
            <Col sm={12} style={{ fontSize: '0.9rem', padding: '8px', color: 'var(--cor-text-secundario)', textAlign: 'center' }}>
                {dados?.texto_conflitos?.map((item, index) => (
                    <h6>{item}</h6>
                ))}
            </Col>
            <Col sm={12} style={{ padding: '8px' }}>
                <Button outline color="primary" onClick={() => atualizarGrupos(false)} className={"float-left btnHeader btnHeader-danger m-0"}>
                    NÃO
                </Button>
                <Button outline color="danger" onClick={() => atualizarGrupos(true)} className={"float-right btnHeader m-0"}>
                    SIM
                </Button>
            </Col>
        </Modal>
    )
}

export default ModalCritiaGrupos